import React from 'react';

const HeadlineIcon = props => (
  <svg viewBox="0 0 10.8 13" style={{ fillRule: 'evenodd' }} {...props}>
    <path
      stroke="none"
      d="M15480.2,1200.71h-10.5v3.08h1a0.468,0.468,0,0,0,.5-0.34v-0.76h2.7v9.26c-0.2.03-.4,0.07-0.5,0.09-0.2.02-.2,0.05-0.3,0.05s-0.1.02-.1,0.02a0.561,0.561,0,0,0-.5.56v1.06h5.2v-1.06a0.561,0.561,0,0,0-.5-0.56s0-.02-0.1-0.02a1.775,1.775,0,0,0-.3-0.05c-0.1-.02-0.3-0.06-0.5-0.09v-9.24h2.7a1.275,1.275,0,0,0,.1.74,0.365,0.365,0,0,0,.4.34h1v-3.08h-0.3Z"
      transform="translate(-15469.7 -1200.72)"
    />
  </svg>
);

export default HeadlineIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/header-icon.js